import type { AnimationGroup } from "@babylonjs/core/Animations/animationGroup";

/** Authored wing/head motion only. Crow owns the existing world departure. */
export class CrowAnimator {
  private departing: boolean;

  static create(groups: readonly AnimationGroup[], elapsed: number | null): CrowAnimator | null {
    const byName = new Map(groups.map(g => [g.name.replace(/^(Clone of )+/, ""), g]));
    const idle = byName.get("idle"), fly = byName.get("fly");
    return idle && fly ? new CrowAnimator(idle, fly, elapsed) : null;
  }

  private constructor(private readonly idle: AnimationGroup, private readonly fly: AnimationGroup, elapsed: number | null) {
    this.departing = elapsed !== null;
    idle.start(true, 1); fly.start(true, 1);
    idle.weight = this.departing ? 0 : 1;
    fly.weight = this.departing ? 1 : 0;
    if (elapsed !== null) this.seekFlight(elapsed);
  }

  depart(): void {
    this.departing = true;
    this.seekFlight(0);
  }

  private seekFlight(elapsed: number): void {
    const fps = this.fly.targetedAnimations[0]?.animation.framePerSecond ?? 60;
    const duration = (this.fly.to - this.fly.from) / fps;
    if (duration > 0) this.fly.goToFrame(this.fly.from + (elapsed % duration) * fps);
  }

  update(dt: number): void {
    if (!this.departing || dt <= 0) return;
    const blend = 1 - Math.exp(-dt / .1);
    this.fly.weight += (1 - this.fly.weight) * blend;
    this.idle.weight = 1 - this.fly.weight;
  }

  dispose(): void {
    this.idle.stop(); this.fly.stop();
  }
}
